<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document">Work Arrangement</i>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row>
                <el-col :span="24" class="searchbar">
                    <el-col :span="2">
                        <label class="searchtitle">Country</label>
                        <el-select v-model="selectcountrychvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectcountrychoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <label class="searchtitle">Project</label>
                        <el-select v-model="selectprojectvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectprojectoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <label class="searchtitle">Brand</label>
                        <el-select v-model="selectbrandvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectbrandoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <label class="searchtitle">Delay</label>
                        <el-select v-model="selectdelayvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectdelayoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <label class="searchtitle">Status</label>
                        <el-select v-model="selectstatusvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectstatusoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Version</label>
                        <el-input
                            style="width:100%;"
                            placeholder="Please Enter SW Version"
                            v-model="selectswversionvalue"
                            clearable>
                        </el-input>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Start Time</label>
                        <el-date-picker
                            style="width:100%"
                            class="formdatepicker"
                            v-model="SearchWorkArrangementstarttime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="Choose Start Time">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">End Time</label>
                        <el-date-picker
                            style="width:100%"
                            class="formdatepicker"
                            v-model="SearchWorkArrangementendtime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="Choose End Time">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="4" style="margin-top:20px;">
                        <el-button size="small" style="margin-left:5px;" type="success" @click="searchWorkArrangement(pagesize,currentpage)">S E A R C H</el-button>
                        <el-button size="small" type="info" @click="clearWorkArrangement">C L E A R</el-button>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <!-- <el-button size="small" type="success" icon="el-icon-download" @click="ExportSearchWorkArrangementTestResult">Export Test Result</el-button> -->
                    <el-button size="small" type="success" icon="el-icon-download" @click="ExportSearchWorkArrangement">Export All Data</el-button>
                    <el-popover
                        v-if="group == 'overseamanager.perm_level_high'"
                        style="margin-left:10px;"
                        placement="bottom"
                        width="160"
                        v-model="DeleteSearchWorkArrangementvisible">
                        <label><h3>Really Delete?</h3></label><br>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="danger" @click="DeleteSearchWorkArrangementvisible = false">NO</el-button>
                            <el-button type="primary" size="mini" @click="DeleteSearchWorkArrangementvisible = false;DeleteSearchWorkArrangement();">YES</el-button>
                        </div>
                        <el-button  slot="reference" size="small" type="warning" icon="el-icon-delete">Delete All Search Content</el-button>              
                    </el-popover>
                    <!-- <el-button size="small" type="warning" icon="el-icon-circle-plus" @click="dialogAddNewWorkArrangementVisible = true">ADD NEW</el-button> -->
                    <el-dialog title="ADD NEW WORK ARRANGEMENT INFO" :visible.sync="dialogAddNewWorkArrangementVisible">
                        <el-form label-position="left" label-width="180px" class="AddNewWorkArrangementForm">
                            <el-form-item label="Country">
                                <el-input v-model="AddNewWorkArrangementFormcountrych" placeholder="Please Enter Country"></el-input>
                            </el-form-item>
                            <el-form-item label="Tester Translater">
                                <el-input v-model="AddNewWorkArrangementFormtestertranslater" placeholder="Please Enter Tester Translater"></el-input>
                            </el-form-item>
                            <el-form-item label="Brand">
                                <el-select class="formselect" v-model="AddNewWorkArrangementFormbrand" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectbrandoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="AddNewWorkArrangementFormbrand" placeholder="Please Enter Brand"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Project">
                                <el-input v-model="AddNewWorkArrangementFormproject" placeholder="Please Enter Project"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Version">
                                <el-input v-model="AddNewWorkArrangementFormswversion" placeholder="Please Enter SW Version"></el-input>
                            </el-form-item>
                            <el-form-item label="Submit Date">
                                <el-date-picker
                                    class="formdatepicker"
                                    style="width:100%;"
                                    v-model="AddNewWorkArrangementFormsubmitdate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Choose Submit Date">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="Start Time">
                                 <el-date-picker
                                    class="formdatepicker"
                                    style="width:100%;"
                                    v-model="AddNewWorkArrangementFormstarttime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Choose Strat Time">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="End Time">
                                <el-date-picker
                                    class="formdatepicker"
                                    style="width:100%;"
                                    v-model="AddNewWorkArrangementFormendtime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Choose End Time">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="Test Man Power">
                                <el-input v-model="AddNewWorkArrangementFormtestmanpower" placeholder="Please Enter Test Man Power"></el-input>
                            </el-form-item>
                            <el-form-item label="Translation Man Power">
                                <el-input v-model="AddNewWorkArrangementFormtranssionmanpower" placeholder="Please Enter Transsion Man Power"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Type">
                                <el-select class="formselect" v-model="AddNewWorkArrangementFormswtype" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectswtypeoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Status">
                                <el-input v-model="AddNewWorkArrangementFormstatus" placeholder="Please Enter Status"></el-input>
                            </el-form-item>
                            <el-form-item label="PL">
                                <el-input v-model="AddNewWorkArrangementFormpl" placeholder="Please Enter PL"></el-input>
                            </el-form-item>
                            <el-form-item label="PPM">
                                <el-input v-model="AddNewWorkArrangementFormppm" placeholder="Please Enter PPM"></el-input>
                            </el-form-item>
                            <el-form-item label="SPM">
                                <el-input v-model="AddNewWorkArrangementFormspm" placeholder="Please Enter SPM"></el-input>
                            </el-form-item>
                            <el-form-item label="TPM">
                                <el-input v-model="AddNewWorkArrangementFormtpm" placeholder="Please Enter TPM"></el-input>
                            </el-form-item>
                            <el-form-item label="Delay">
                                <el-input v-model="AddNewWorkArrangementFormdelay" placeholder="Please Enter Delay"></el-input>
                            </el-form-item>
                            <el-form-item label="Test Plan">
                                <el-input v-model="AddNewWorkArrangementFormtestplan" placeholder="Please Enter Test Plan"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Link">
                                <el-input v-model="AddNewWorkArrangementFormswlink" placeholder="Please Enter SW Link"></el-input>
                            </el-form-item>
                            <el-form-item label="Type">
                                <el-input v-model="AddNewWorkArrangementFormtype" placeholder="Please Enter Type"></el-input>
                            </el-form-item>
                            <el-form-item label="Delay Reason">
                                <el-input v-model="AddNewWorkArrangementFormdelayreason" placeholder="Please Enter Delay Reason"></el-input>
                            </el-form-item>
                            <el-form-item label="Result">
                                <el-input v-model="AddNewWorkArrangementFormresult" placeholder="Please Enter Result"></el-input>
                            </el-form-item>
                            <el-form-item label="Results Time">
                                <el-date-picker
                                    class="formdatepicker"
                                    style="width:100%;"
                                    v-model="AddNewWorkArrangementFormresultstime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Choose Results Time">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="Comment">
                                <el-input v-model="AddNewWorkArrangementFormcomment" placeholder="Please Enter Comment"></el-input>
                            </el-form-item>
                            <el-form-item label="Password">
                                <el-input v-model="AddNewWorkArrangementFormpassword" placeholder="Please Enter Password"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogAddNewWorkArrangementVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="AddNewWorkArrangement">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-table
                        ref="WorkArrangementTable"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        height="500"
                        border
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <!-- `<el-table-column
                            type="selection"
                            width="5px">
                        </el-table-column>` -->
                        <el-table-column
                            prop="id"
                            label="ID"
                            align="center"
                            v-if="idshow"
                            width="10px">
                        </el-table-column>
                        <el-table-column
                            prop="countrych"
                            label="Country"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testertranslater"
                            label="Tester Translater"
                            align="center"
                            width="140px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="brand"
                            label="Brand"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="project"
                            label="Project"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swversion"
                            label="SW Version"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <a  herf='#'
                                    v-clipboard:copy="scope.row.swversion"
                                    v-clipboard:success="onCopy"
                                    v-clipboard:error="onError">
                                    {{ scope.row.swversion }}
                                </a>                               
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="submitdate"
                            label="Submit Date"
                            align="center"
                            width="110px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="starttime"
                            label="Start Time"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="endtime"
                            label="End Time"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swtype"
                            label="SW Type"
                            align="center"
                            width="90px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="Status"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="result"
                            label="Result"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="resultstime"
                            label="Results Time"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="priority"
                            label="Priority"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="projectleader"
                            label="PL"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="ppm"
                            label="PPM"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="spm"
                            label="SPM"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="tpm"
                            label="TPM"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="delay"
                            label="Delay"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testplan"
                            label="Test Plan"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swlink"
                            label="SW Link"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="password"
                            label="Password"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="delayreason"
                            label="Delay Reason"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testmanpower"
                            label="Test Man Power"
                            align="center"
                            width="130px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="transsionmanpower"
                            label="Translation Man Power"
                            align="center"
                            width="180px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="sample_number"
                            label="Sample Number"
                            align="center"
                            width="130px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="comment"
                            label="Comment"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column 
                            fixed="right"
                            label="Operation"
                            align="center"
                            width="160px">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                @click="dialogEditWorkArrangementVisible = true;handleEdit(scope.$index, scope.row);">Edit</el-button>                                
                                <el-button
                                size="mini"
                                v-if="group == 'overseamanager.perm_level_high' || group == 'overseamanager.perm_level_middle'"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog title="EDIT WORK ARRANGEMENT INFO" :visible.sync="dialogEditWorkArrangementVisible" style="width:120%;margin-top:-50px;margin-left:-100px;">
                        <el-form label-position="left" label-width="180px" class="EditWorkArrangementForm">
                            <el-col :span="24">
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Country">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormcountrych" placeholder="Please Enter Country"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="SW Version">
                                        <el-input :disabled="group == 'overseamanager.perm_level_low'" v-model="EditWorkArrangementFormswversion" placeholder="Please Enter SW Version"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Status">
                                        <el-select class="formselect" v-model="EditWorkArrangementFormstatus" filterable placeholder="please select">
                                            <el-option
                                            v-for="item in selectstatusoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditWorkArrangementFormstatus" placeholder="Please Enter Status"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Start Time">
                                        <el-date-picker
                                            class="formdatepicker"
                                            style="width:100%;"
                                            :disabled="group == 'overseamanager.perm_level_low' ||group == 'overseamanager.perm_level_middle' "
                                            v-model="EditWorkArrangementFormstarttime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Strat Time">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="End Time">
                                        <el-date-picker
                                            class="formdatepicker"
                                            style="width:100%;"
                                            :disabled="group == 'overseamanager.perm_level_low' ||group == 'overseamanager.perm_level_middle'"
                                            v-model="EditWorkArrangementFormendtime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose End Time">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Result">
                                        <el-select class="formselect" 
                                            :disabled="group == 'overseamanager.perm_level_low' && EditWorkArrangementFormstatus != 'Closed'"
                                            v-model="EditWorkArrangementFormresult"
                                            filterable placeholder="please select">
                                            <el-option
                                            v-for="item in selectresultoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditWorkArrangementFormresult" placeholder="Please Enter Result"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Results Time">
                                        <el-date-picker
                                            :disabled="group == 'overseamanager.perm_level_low' && EditWorkArrangementFormstatus != 'Closed'"
                                            class="formdatepicker"
                                            style="width:100%;"
                                            v-model="EditWorkArrangementFormresultstime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Results Time">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Delay">
                                        <el-select class="formselect" 
                                            v-model="EditWorkArrangementFormdelay" 
                                            filterable 
                                            :disabled="group == 'overseamanager.perm_level_low'"
                                            placeholder="please select">
                                            <el-option
                                            v-for="item in selectdelayoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditWorkArrangementFormdelay" placeholder="Please Enter Delay"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Delay Reason">
                                        <el-input v-model="EditWorkArrangementFormdelayreason"
                                            :disabled="group == 'overseamanager.perm_level_low'" 
                                            placeholder="Please Enter Delay Reason"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Test Man Power">
                                        <el-input v-model="EditWorkArrangementFormtestmanpower" placeholder="Please Enter Test Man Power"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Translation Man Power">
                                        <el-input v-model="EditWorkArrangementFormtranssionmanpower" placeholder="Please Enter Transsion Man Power"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Tester Translater">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormtestertranslater" placeholder="Please Enter Tester Translater"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Brand">
                                        <el-select class="formselect" disabled v-model="EditWorkArrangementFormbrand" filterable placeholder="please select">
                                            <el-option
                                            v-for="item in selectbrandoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditWorkArrangementFormbrand" placeholder="Please Enter Brand"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Project">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormproject" placeholder="Please Enter Project"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Submit Date">
                                        <el-date-picker
                                            class="formdatepicker"
                                            style="width:100%;"
                                            v-model="EditWorkArrangementFormsubmitdate"
                                            type="date"
                                            disabled
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Submit Date">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="SW Type">
                                        <el-select :disabled="group == 'overseamanager.perm_level_low'" class="formselect" v-model="EditWorkArrangementFormswtype" filterable placeholder="please select">
                                            <el-option
                                            v-for="item in selectswtypeoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Priority">
                                        <el-select :disabled="group == 'overseamanager.perm_level_low'" class="formselect" v-model="EditWorkArrangementFormpriority" filterable placeholder="please select Priority">
                                            <el-option
                                            v-for="item in selectpriorityoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="PL">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormpl" placeholder="Please Enter PL"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="PPM">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormppm" placeholder="Please Enter PPM"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="SPM">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormspm" placeholder="Please Enter SPM"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="TPM">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormtpm" placeholder="Please Enter TPM"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Test Plan">
                                        <el-input :disabled="group == 'overseamanager.perm_level_low'" v-model="EditWorkArrangementFormtestplan" placeholder="Please Enter Test Plan"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="SW Link">
                                        <el-input :disabled="group == 'overseamanager.perm_level_low'" v-model="EditWorkArrangementFormswlink" placeholder="Please Enter SW Link"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Type">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormtype" placeholder="Please Enter Type"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" class="editcol">
                                    <el-form-item label="Comment">
                                        <el-input type="textarea" :autosize="{ minRows: 3}" :disabled="true" v-model="EditWorkArrangementFormcomment" placeholder="Please Enter Comment"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Password">
                                        <el-input :disabled="true" v-model="EditWorkArrangementFormpassword" placeholder="Please Enter Password"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="BUG Close Number">
                                        <el-input v-model="EditWorkArrangementFormBUGCloseNumber" placeholder="Please Enter BUG Close Number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="BUG Legacy Number">
                                        <el-input v-model="EditWorkArrangementFormBUGLegacyNumber" placeholder="Please Enter BUG Legacy Number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="BUG New Number">
                                        <el-input v-model="EditWorkArrangementFormBUGNewNumber" placeholder="Please Enter BUG New Number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="BUG Total Number">
                                        <el-input v-model="EditWorkArrangementFormBUGTotalNumber" placeholder="Please Enter BUG Total Number"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogEditWorkArrangementVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="EditWorkArrangement">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-sizes="[8, 15, 30, 50]"
                        :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="currentTotal"
                        >
                    </el-pagination>
                </el-col>
            </el-row>
        </div>    
    </div>
</template>

<script>
import { searchWorkArrangementData,AddNewWorkArrangementData,DeleteSearchWorkArrangementData,EditWorkArrangementData,DeleteWorkArrangementData,GetWorkArrangementSelectOption,ExportSearchWorkArrangementData,ExportSearchWorkArrangementTestResultData } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            group:"",
            currentpage: 1,
            pagesize: 8,
            currentTotal: 0,
            tableData: [],
            multipleSelection: [],
            loading: false,
            idshow: false,
            DeleteSearchWorkArrangementvisible: false,
            SearchWorkArrangementstarttime:"",
            SearchWorkArrangementendtime:"",
            selectcountrychoptions: [],
            selectcountrychvalue: '',
            selectprojectoptions: [],
            selectprojectvalue: '',
            selectswversionoptions: [],
            selectswversionvalue: '',
            selectbrandoptions: [],
            selectbrandvalue: '',
            selectswtypeoptions: [],
            selectstatusvalue: '',
            selectstatusoptions: [],
            selectpriorityoptions: [
                {
                    value:"AA",
                    label:"AA"
                },
                {
                    value:"A",
                    label:"A"
                },
                {
                    value:"B",
                    label:"B"
                },
                {
                    value:"C",
                    label:"C"
                },
            ],
            selectdelayoptions: [
                {
                    value:"",
                    label:""
                },
                {
                    value:"Delay",
                    label:"Delay"
                }
            ],
            selectdelayvalue:'',
            selectresultoptions: [
                {
                    value:"",
                    label:""
                },
                {
                    value:"pass",
                    label:"Pass"
                },
                {
                    value:"fail",
                    label:"Fail"
                },
                {
                    value:"cancel",
                    label:"Cancel"
                }
            ],
            dialogAddNewWorkArrangementVisible:false,
            AddNewWorkArrangementFormcountrych: '',
            AddNewWorkArrangementFormtestertranslater: '',
            AddNewWorkArrangementFormbrand: '',
            AddNewWorkArrangementFormproject: '',
            AddNewWorkArrangementFormswversion: '',
            AddNewWorkArrangementFormsubmitdate: '',
            AddNewWorkArrangementFormstarttime: '',
            AddNewWorkArrangementFormendtime: '',
            AddNewWorkArrangementFormtestmanpower: '',
            AddNewWorkArrangementFormtranssionmanpower: '',
            AddNewWorkArrangementFormswtype: '',
            AddNewWorkArrangementFormstatus: '',
            AddNewWorkArrangementFormpl: '',
            AddNewWorkArrangementFormppm: '',
            AddNewWorkArrangementFormspm: '',
            AddNewWorkArrangementFormtpm: '',
            AddNewWorkArrangementFormdelay: '',
            AddNewWorkArrangementFormtestplan: '',
            AddNewWorkArrangementFormswlink: '',
            AddNewWorkArrangementFormtype: '',
            AddNewWorkArrangementFormdelayreason: '',
            AddNewWorkArrangementFormresult: '',
            AddNewWorkArrangementFormresultstime: '',
            AddNewWorkArrangementFormcomment: '',
            AddNewWorkArrangementFormpassword: '',
            dialogEditWorkArrangementVisible:false,
            EditWorkArrangementFormid: '',
            EditWorkArrangementFormauthor: '',
            EditWorkArrangementFormcountrych: '',
            EditWorkArrangementFormtestertranslater: '',
            EditWorkArrangementFormbrand: '',
            EditWorkArrangementFormproject: '',
            EditWorkArrangementFormswversion: '',
            EditWorkArrangementFormsubmitdate: '',
            EditWorkArrangementFormstarttime: '',
            EditWorkArrangementFormendtime: '',
            EditWorkArrangementFormtestmanpower: '',
            EditWorkArrangementFormtranssionmanpower: '',
            EditWorkArrangementFormswtype: '',
            EditWorkArrangementFormstatus: '',
            EditWorkArrangementFormpriority: '',
            EditWorkArrangementFormpl: '',
            EditWorkArrangementFormppm: '',
            EditWorkArrangementFormspm: '',
            EditWorkArrangementFormtpm: '',
            EditWorkArrangementFormdelay: '',
            EditWorkArrangementFormtestplan: '',
            EditWorkArrangementFormswlink: '',
            EditWorkArrangementFormtype: '',
            EditWorkArrangementFormdelayreason: '',
            EditWorkArrangementFormresult: '',
            EditWorkArrangementFormresultstime: '',
            EditWorkArrangementFormcomment: '',
            EditWorkArrangementFormpassword: '',
            EditWorkArrangementFormBUGCloseNumber: '',
            EditWorkArrangementFormBUGLegacyNumber: '',
            EditWorkArrangementFormBUGNewNumber: '',
            EditWorkArrangementFormBUGTotalNumber: ''
        };
    },
    created() {
        this.group = localStorage.getItem("Group");
        let token = this.$store.getters.idToken;
        searchWorkArrangementData ({
            countrych: "",
            project: "",
            brand: "",
            swversion: "",
            delay: "",
            status: "",
            starttime: "",
            endtime: "",
            pagesize: this.pagesize,
            currentpage: this.currentpage
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.count;
        }).catch(error => console.log(error));
        GetWorkArrangementSelectOption (token).then(res => {
            console.log(res);
            this.selectcountrychoptions = res.countrych;
            this.selectprojectoptions = res.project;
            this.selectbrandoptions = res.brand;
            this.selectswtypeoptions = res._type;
            this.selectstatusoptions = res.status;
        }).catch(error => console.log(error));
    },
    methods: {
        handleSizeChange(val) {
            this.pagesize = val;
            console.log(`每页 ${val} 条`);
            this.searchWorkArrangement(val,this.currentpage);
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            console.log(`当前页: ${val}`);
            this.searchWorkArrangement(this.pagesize,val);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        handleEdit(index, row) {
            console.log(index, row);
            this.EditWorkArrangementFormid = row.id ;
            this.EditWorkArrangementFormauthor = row.author ;
            this.EditWorkArrangementFormcountrych = row.countrych;
            this.EditWorkArrangementFormtestertranslater = row.testertranslater;
            this.EditWorkArrangementFormbrand = row.brand;
            this.EditWorkArrangementFormproject = row.project;
            this.EditWorkArrangementFormswversion = row.swversion;
            this.EditWorkArrangementFormsubmitdate = row.submitdate;
            this.EditWorkArrangementFormstarttime = row.starttime;
            this.EditWorkArrangementFormendtime = row.endtime;
            this.EditWorkArrangementFormtestmanpower = row.testmanpower;
            this.EditWorkArrangementFormtranssionmanpower = row.transsionmanpower;
            this.EditWorkArrangementFormswtype = row.swtype;
            this.EditWorkArrangementFormstatus = row.status;
            this.EditWorkArrangementFormpriority = row.priority;
            this.EditWorkArrangementFormpl = row.projectleader;
            this.EditWorkArrangementFormppm = row.ppm;
            this.EditWorkArrangementFormspm = row.spm;
            this.EditWorkArrangementFormtpm = row.tpm;
            this.EditWorkArrangementFormdelay = row.delay;
            this.EditWorkArrangementFormtestplan = row.testplan;
            this.EditWorkArrangementFormswlink = row.swlink;
            this.EditWorkArrangementFormtype = row.type;
            this.EditWorkArrangementFormdelayreason = row.delayreason;
            this.EditWorkArrangementFormresult = row.result;
            this.EditWorkArrangementFormresultstime = row.resultstime;
            this.EditWorkArrangementFormcomment = row.comment;
            this.EditWorkArrangementFormpassword = row.password;
            this.EditWorkArrangementFormBUGCloseNumber = row.bug_close;
            this.EditWorkArrangementFormBUGLegacyNumber = row.bug_legacy;
            this.EditWorkArrangementFormBUGNewNumber = row.bug_new;
            this.EditWorkArrangementFormBUGTotalNumber = row.bug_total;
        },
        handleDelete(index, row) {
            let token = this.$store.getters.idToken;
            console.log(index, row);
            console.log(row.id);
            this.$confirm('此Operation将永久Delete该文件, 是否继续?', '提示', {
                confirmButtonText: 'OK',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                DeleteWorkArrangementData ({
                    id: row.id
                },token).then(res => {
                    console.log(res);
                    this.tableData.splice(((this.currentpage-1)*this.pagesize+index), 1);
                    this.currentTotal--;
                    this.$message({
                        type: 'success',
                        message: 'Delete successful'
                    });
                    GetWorkArrangementSelectOption (token).then(res => {
                        console.log(res);
                        this.selectcountrychoptions = res.countrych;
                        this.selectprojectoptions = res.project;
                        this.selectbrandoptions = res.brand;
                        this.selectswtypeoptions = res._type;
                    }).catch(error => console.log(error));
                }).catch(error => console.log(error));
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Delete canceled'
                });          
            });            
        },
        searchWorkArrangement (pagesize,currentpage) {
            let token = this.$store.getters.idToken;
            this.loading = true;
            searchWorkArrangementData ({
                countrych: this.selectcountrychvalue,
                project: this.selectprojectvalue,
                brand: this.selectbrandvalue,
                swversion: this.selectswversionvalue,
                delay: this.selectdelayvalue,
                status: this.selectstatusvalue,
                starttime: this.SearchWorkArrangementstarttime,
                endtime: this.SearchWorkArrangementendtime,
                pagesize: pagesize,
                currentpage: currentpage
            },token).then(res => {
                this.tableData = res.results;
                console.log(res.results);
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetWorkArrangementSelectOption (token).then(res => {
                console.log(res);
                this.selectcountrychoptions = res.countrych;
                this.selectprojectoptions = res.project;
                this.selectbrandoptions = res.brand;
                this.selectswtypeoptions = res._type;
            }).catch(error => console.log(error));
        },
        clearWorkArrangement () {
            let token = this.$store.getters.idToken;
            this.selectcountrychvalue = "";
            this.selectprojectvalue = "";
            this.selectbrandvalue = "";
            this.selectswversionvalue = "";
            this.selectdelayvalue = "";
            this.selectstatusvalue = "";
            this.SearchWorkArrangementstarttime = "";
            this.SearchWorkArrangementendtime = "";
            this.currentpage = 1;
            this.loading = true;
            searchWorkArrangementData ({
                countrych: "",
                project: "",
                brand: "",
                swversion: "",
                delay: "",
                status: "",
                starttime: "",
                endtime: "",
                pagesize: this.pagesize,
                currentpage: this.currentpage
            },token).then(res => {
                this.tableData = res.results;
                console.log(res.results);
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetWorkArrangementSelectOption (token).then(res => {
                console.log(res);
                this.selectcountrychoptions = res.countrych;
                this.selectprojectoptions = res.project;
                this.selectbrandoptions = res.brand;
                this.selectswtypeoptions = res._type;
            }).catch(error => console.log(error));
        },
        AddNewWorkArrangement() {
            let token = this.$store.getters.idToken;
            const AddNewWorkArrangementFormData = {
                countrych: this.AddNewWorkArrangementFormcountrych,
                testertranslater: this.AddNewWorkArrangementFormtestertranslater,
                brand: this.AddNewWorkArrangementFormbrand,
                project: this.AddNewWorkArrangementFormproject,
                swversion: this.AddNewWorkArrangementFormswversion,
                submitdate: this.AddNewWorkArrangementFormsubmitdate,
                starttime: this.AddNewWorkArrangementFormstarttime,
                endtime: this.AddNewWorkArrangementFormendtime,
                testmanpower: this.AddNewWorkArrangementFormtestmanpower,
                transsionmanpower: this.AddNewWorkArrangementFormtranssionmanpower,
                swtype: this.AddNewWorkArrangementFormswtype,
                status: this.AddNewWorkArrangementFormstatus,
                projectleader: this.AddNewWorkArrangementFormpl,
                ppm: this.AddNewWorkArrangementFormppm,
                spm: this.AddNewWorkArrangementFormspm,
                tpm: this.AddNewWorkArrangementFormtpm,
                delay: this.AddNewWorkArrangementFormdelay,
                testplan: this.AddNewWorkArrangementFormtestplan,
                swlink: this.AddNewWorkArrangementFormswlink,
                type: this.AddNewWorkArrangementFormtype,
                delayreason: this.AddNewWorkArrangementFormdelayreason,
                result: this.AddNewWorkArrangementFormresult,
                resultstime: this.AddNewWorkArrangementFormresultstime,
                comment: this.AddNewWorkArrangementFormcomment,
                password: this.AddNewWorkArrangementFormpassword
            }
            AddNewWorkArrangementData (AddNewWorkArrangementFormData,token).then(res => {
                if (res != "") {
                    console.log(res);
                    console.log(this.tableData);
                    const AddNewItemRes = {
                        countrych: this.AddNewWorkArrangementFormcountrych,
                        testertranslater: this.AddNewWorkArrangementFormtestertranslater,
                        brand: this.AddNewWorkArrangementFormbrand,
                        project: this.AddNewWorkArrangementFormproject,
                        swversion: this.AddNewWorkArrangementFormswversion,
                        submitdate: this.AddNewWorkArrangementFormsubmitdate,
                        starttime: this.AddNewWorkArrangementFormstarttime,
                        endtime: this.AddNewWorkArrangementFormendtime,
                        testmanpower: this.AddNewWorkArrangementFormtestmanpower,
                        transsionmanpower: this.AddNewWorkArrangementFormtranssionmanpower,
                        swtype: this.AddNewWorkArrangementFormswtype,
                        status: this.AddNewWorkArrangementFormstatus,
                        projectleader: this.AddNewWorkArrangementFormpl,
                        ppm: this.AddNewWorkArrangementFormppm,
                        spm: this.AddNewWorkArrangementFormspm,
                        tpm: this.AddNewWorkArrangementFormtpm,
                        delay: this.AddNewWorkArrangementFormdelay,
                        testplan: this.AddNewWorkArrangementFormtestplan,
                        swlink: this.AddNewWorkArrangementFormswlink,
                        type: this.AddNewWorkArrangementFormtype,
                        delayreason: this.AddNewWorkArrangementFormdelayreason,
                        result: this.AddNewWorkArrangementFormresult,
                        resultstime: this.AddNewWorkArrangementFormresultstime,
                        comment: this.AddNewWorkArrangementFormcomment,
                        password: this.AddNewWorkArrangementFormpassword
                    };
                    this.tableData.push(AddNewItemRes);
                    this.currentTotal++;
                    this.$message({
                        message: 'Added successfully',
                        type: 'success'
                    });
                    GetWorkArrangementSelectOption (token).then(res => {
                        console.log(res);
                        this.selectcountrychoptions = res.countrych;
                        this.selectprojectoptions = res.project;
                        this.selectbrandoptions = res.brand;
                        this.selectswtypeoptions = res._type;
                    }).catch(error => console.log(error));
                    this.AddNewWorkArrangementFormcountrych = "";
                    this.AddNewWorkArrangementFormtestertranslater = "";
                    this.AddNewWorkArrangementFormbrand = "";
                    this.AddNewWorkArrangementFormproject = "";
                    this.AddNewWorkArrangementFormswversion = "";
                    this.AddNewWorkArrangementFormsubmitdate = "";
                    this.AddNewWorkArrangementFormstarttime = "";
                    this.AddNewWorkArrangementFormendtime = "";
                    this.AddNewWorkArrangementFormtestmanpower = "";
                    this.AddNewWorkArrangementFormtranssionmanpower = "";
                    this.AddNewWorkArrangementFormswtype = "";
                    this.AddNewWorkArrangementFormstatus = "";
                    this.AddNewWorkArrangementFormpl = "";
                    this.AddNewWorkArrangementFormppm = "";
                    this.AddNewWorkArrangementFormspm = "";
                    this.AddNewWorkArrangementFormtpm = "";
                    this.AddNewWorkArrangementFormdelay = "";
                    this.AddNewWorkArrangementFormtestplan = "";
                    this.AddNewWorkArrangementFormswlink = "";
                    this.AddNewWorkArrangementFormtype = "";
                    this.AddNewWorkArrangementFormdelayreason = "";
                    this.AddNewWorkArrangementFormresult = "";
                    this.AddNewWorkArrangementFormresultstime = "";
                    this.AddNewWorkArrangementFormcomment = "";
                    this.AddNewWorkArrangementFormpassword = "";
                    this.dialogAddNewWorkArrangementVisible = false;                    
                }
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Sorry, failed to add'
                });          
            });
        },
        EditWorkArrangement() {
            let token = this.$store.getters.idToken;
            const EditWorkArrangementFormData = {
                id: this.EditWorkArrangementFormid,
                author: this.EditWorkArrangementFormauthor,
                countrych: this.EditWorkArrangementFormcountrych,
                testertranslater: this.EditWorkArrangementFormtestertranslater,
                brand: this.EditWorkArrangementFormbrand,
                project: this.EditWorkArrangementFormproject,
                swversion: this.EditWorkArrangementFormswversion,
                submitdate: this.EditWorkArrangementFormsubmitdate,
                starttime: this.EditWorkArrangementFormstarttime,
                endtime: this.EditWorkArrangementFormendtime,
                testmanpower: this.EditWorkArrangementFormtestmanpower,
                transsionmanpower: this.EditWorkArrangementFormtranssionmanpower,
                swtype: this.EditWorkArrangementFormswtype,
                status: this.EditWorkArrangementFormstatus,
                priority: this.EditWorkArrangementFormpriority,
                projectleader: this.EditWorkArrangementFormpl,
                ppm: this.EditWorkArrangementFormppm,
                spm: this.EditWorkArrangementFormspm,
                tpm: this.EditWorkArrangementFormtpm,
                delay: this.EditWorkArrangementFormdelay,
                testplan: this.EditWorkArrangementFormtestplan,
                swlink: this.EditWorkArrangementFormswlink,
                type: this.EditWorkArrangementFormtype,
                delayreason: this.EditWorkArrangementFormdelayreason,
                result: this.EditWorkArrangementFormresult,
                resultstime: this.EditWorkArrangementFormresultstime,
                comment: this.EditWorkArrangementFormcomment,
                password: this.EditWorkArrangementFormpassword,
                bug_close: this.EditWorkArrangementFormBUGCloseNumber,
                bug_legacy: this.EditWorkArrangementFormBUGLegacyNumber,
                bug_new: this.EditWorkArrangementFormBUGNewNumber,
                bug_total: this.EditWorkArrangementFormBUGTotalNumber,
            }
            EditWorkArrangementData (this.EditWorkArrangementFormid,EditWorkArrangementFormData,token).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '恭喜你，Modified successfully',
                        type: 'success'
                    });
                    for (var i = 0;i < this.tableData.length;i++) {
                        if (this.EditWorkArrangementFormid == this.tableData[i].id) {
                            this.tableData[i].countrych = EditWorkArrangementFormData.countrych;
                            this.tableData[i].testertranslater = EditWorkArrangementFormData.testertranslater;
                            this.tableData[i].brand = EditWorkArrangementFormData.brand;
                            this.tableData[i].project = EditWorkArrangementFormData.project;
                            this.tableData[i].swversion = EditWorkArrangementFormData.swversion;
                            this.tableData[i].submitdate = EditWorkArrangementFormData.submitdate;
                            this.tableData[i].starttime = EditWorkArrangementFormData.starttime;
                            this.tableData[i].endtime = EditWorkArrangementFormData.endtime;
                            this.tableData[i].testmanpower = EditWorkArrangementFormData.testmanpower;
                            this.tableData[i].transsionmanpower = EditWorkArrangementFormData.transsionmanpower;
                            this.tableData[i].swtype = EditWorkArrangementFormData.swtype;
                            this.tableData[i].status = EditWorkArrangementFormData.status;
                            this.tableData[i].priority = EditWorkArrangementFormData.priority;
                            this.tableData[i].projectleader = EditWorkArrangementFormData.projectleader;
                            this.tableData[i].ppm = EditWorkArrangementFormData.ppm;
                            this.tableData[i].spm = EditWorkArrangementFormData.spm;
                            this.tableData[i].tpm = EditWorkArrangementFormData.tpm;
                            this.tableData[i].delay = EditWorkArrangementFormData.delay;
                            this.tableData[i].testplan = EditWorkArrangementFormData.testplan;
                            this.tableData[i].swlink = EditWorkArrangementFormData.swlink;
                            this.tableData[i].type = EditWorkArrangementFormData.type;
                            this.tableData[i].delayreason = EditWorkArrangementFormData.delayreason;
                            this.tableData[i].result = EditWorkArrangementFormData.result;
                            this.tableData[i].resultstime = EditWorkArrangementFormData.resultstime;
                            this.tableData[i].comment = EditWorkArrangementFormData.comment;
                            this.tableData[i].password = EditWorkArrangementFormData.password;
                            this.tableData[i].bug_close = EditWorkArrangementFormData.bug_close;
                            this.tableData[i].bug_legacy = EditWorkArrangementFormData.bug_legacy;
                            this.tableData[i].bug_new = EditWorkArrangementFormData.bug_new;
                            this.tableData[i].bug_total = EditWorkArrangementFormData.bug_total;
                            console.log(this.tableData[i]);
                        }
                    }
                    GetWorkArrangementSelectOption (token).then(res => {
                        console.log(res);
                        this.selectcountrychoptions = res._country;
                        this.selectprojectoptions = res.project;
                        this.selectbrandoptions = res.brand;
                        this.selectswtypeoptions = res._type;
                    }).catch(error => console.log(error));
                    this.dialogEditWorkArrangementVisible = false;
                    // this.$router.push({path:'/WorkArrangement'});
                }else {
                    this.$message({
                        type: 'warning',
                        message: res.msg
                    });   
                }
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: error.msg
                });            
            });  
            // .catch(error => console.log(error));
                      
        },
        DeleteSearchWorkArrangement() {
            let token = this.$store.getters.idToken;
            const loading = this.$loading({
                lock: true,
                text: 'Deleting',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if(this.selectcountrychvalue == "" && this.selectprojectvalue == "" && this.selectswversionvalue == "") {
                this.$message({
                    type: 'warning',
                    message: 'Please Choose One Condition!'
                });
                loading.close();
            }else {
                DeleteSearchWorkArrangementData ({
                    countrych: this.selectcountrychvalue,
                    project: this.selectprojectvalue,
                    swversion: this.selectswversionvalue,
                },token).then(res => {
                    console.log(res);
                    if(res.results == 1) {
                        this.$message({
                            type: 'success',
                            message: 'Delete Success!'
                        });
                        loading.close();
                        this.searchWorkArrangement();
                    }else {
                        this.$message({
                            type: 'warning',
                            message: 'Delete Failed!'
                        });
                        loading.close();
                    }                    
                }).catch(error => console.log(error));
            }            
        },
        ExportSearchWorkArrangementTestResult() {
            let token = this.$store.getters.idToken;
            const loading = this.$loading({
                lock: true,
                text: 'Exporting',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if(this.selectswversionvalue == "") {
                this.$message({
                    type: 'warning',
                    message: 'Please Choose SW Version!'
                });
                loading.close();
            }else {
                ExportSearchWorkArrangementTestResultData ({
                    swversion: this.selectswversionvalue,
                },token).then(res => {
                    // console.log(res);
                    if(res.code == 1) {
                        this.$message({
                            type: 'success',
                            message: 'Export Success!'
                        });
                        window.location.href = res.url;
                        loading.close();
                    }else {
                        this.$message({
                            type: 'warning',
                            message: 'Export Failed!'
                        });
                        loading.close();
                    }                    
                }).catch(error => console.log(error));
            }            
        },
        ExportSearchWorkArrangement() {
            let token = this.$store.getters.idToken;
            const loading = this.$loading({
                lock: true,
                text: 'Exporting',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            ExportSearchWorkArrangementData (token).then(res => {
                // console.log(res);
                if(res.code == 1) {
                    this.$message({
                        type: 'success',
                        message: 'Export Success!'
                    });
                    window.location.href = res.url;
                    loading.close();
                }else {
                    this.$message({
                        type: 'warning',
                        message: 'Export Failed!'
                    });
                    loading.close();
                }                    
            }).catch(error => console.log(error));     
        },
        onCopy: function (e) {
            this.$message({
                type: 'success',
                message: 'You just copied: ' + e.text
            });
        },
        onError: function (e) {
            this.$message({
                type: 'warning',
                message: 'Failed to copy texts!'
            });
        }
    }
};
</script>

<style scoped>
    .searchtitle {
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
    }
    .searchbar {
        padding: 20px 0px;
        margin-top:-30px;
    }
    .AddNewWorkArrangementForm {
        font-weight: bold;
        font-size: 16px;
    }
    .formselect {
        width: 100%;
    }
    .formitemborder {
        border:3px solid rgb(236, 15, 15)
    }
    .editcol {
        padding: 0 10px;
    }
</style>
